import { Box, ButtonBase, Tooltip } from "@mui/material";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";

type Props = { onClick: () => void };

export default function FreeCreditPill({ onClick }: Props) {
  return (
    <Tooltip
      title="Earn free credits by helping spread the word about Sigil."
      enterDelay={300}
    >
      <ButtonBase
        onClick={onClick}
        sx={{
          px: 1.25,
          py: 0.5,
          borderRadius: 999,
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.85) 0%, rgba(255,255,255,0.72) 100%)",
          boxShadow:
            "0 1px 0 rgba(0,0,0,0.08), inset 0 0 0 1px rgba(0,0,0,0.10)",
          display: "inline-flex",
          alignItems: "center",
          gap: 0.75,
          transition: "transform 120ms ease, box-shadow 120ms ease",
          "&:hover": {
            transform: "translateY(-1px)",
            boxShadow:
              "0 2px 8px rgba(0,0,0,0.18), inset 0 0 0 1px rgba(0,0,0,0.12)",
          },
        }}
      >
        <Box
          sx={{
            width: 18,
            height: 18,
            borderRadius: "50%",
            backgroundColor: "#0A0A0A",
            display: "grid",
            placeItems: "center",
          }}
        >
          <CardGiftcardIcon sx={{ fontSize: 14, color: "#fff" }} />
        </Box>
        <Box
          component="span"
          sx={{
            fontWeight: 700,
            fontSize: "0.75rem",
            letterSpacing: "0.02em",
            color: "#1B1B1B",
            whiteSpace: "nowrap",
          }}
        >
          Get free credits
        </Box>
      </ButtonBase>
    </Tooltip>
  );
}
